import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DepartmentInput, DepartmentResult, GetDepartmentsInput, Result, ResultList } from 'app/models';
import { Utility } from 'app/shared';
import { plainToClassFromExist } from 'class-transformer';

@Injectable({
  providedIn: 'root'
})
export class DepartmentService {

  constructor(private httpClient: HttpClient) { }

  public addDepartment(departmentInput: DepartmentInput): Promise<Result> {
    return this.httpClient.post(Utility.serviceAddress + 'Department/AddDepartment', departmentInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public editDepartment(id: number, departmentInput: DepartmentInput): Promise<Result> {
    return this.httpClient.put(Utility.serviceAddress + 'Department/EditDepartment?id=' + id, departmentInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public deleteDepartment(id: number): Promise<Result> {
    return this.httpClient.delete(Utility.serviceAddress + 'Department/DeleteDepartment?id=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public getDepartments(getDepartmentsInput: GetDepartmentsInput): Promise<ResultList<DepartmentResult>> {
    return this.httpClient.post(Utility.serviceAddress + 'Department/GetDepartments', getDepartmentsInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new ResultList<DepartmentResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<DepartmentResult>(), result.error));
  }
}